import { HTTP_TOKEN, HTTP } from "./http";

export const saveIntegration = (data) => {
  return HTTP_TOKEN.post("integration", data).then((result) => {
    return result.data;
  });
};

export const getIntegrations = () => {
  return HTTP_TOKEN.get("integration").then((result) => {
    return result.data;
  });
};

export const deleteIntegration = (integrationDataId) => {
  return HTTP_TOKEN.delete(`integration/${integrationDataId}`).then(
    (result) => {
      return result.data;
    }
  );
};

export const initGoogleOauth2 = () => {
  return HTTP_TOKEN.get("integration/oauth/google").then((result) => {
    return result.data;
  });
};

export const initFacebookOauth2 = () => {
  return HTTP_TOKEN.get("integration/oauth/facebook").then((result) => {
    return result.data;
  });
};

export const initTikTokOauth2 = () => {
  return HTTP_TOKEN.get("integration/oauth/tiktok").then((result) => {
    return result.data;
  });
};

export const getAccountsFacebookAds = () => {
  return HTTP_TOKEN.get("integration/external/facebook/list_accounts_ads").then(
    (result) => {
      return result.data;
    }
  );
};

export const getAccountsGoogleAds = () => {
  return HTTP_TOKEN.get("integration/external/google/list_accounts_ads").then(
    (result) => {
      return result.data;
    }
  );
};

export const getCampaignFacebookAccount = (data) => {
  return HTTP_TOKEN.get(
    "integration/external/facebook/list_campaigns_from_account",
    {
      params: data,
    }
  ).then((result) => {
    return result.data;
  });
};

export const getCampaignGoogleAccount = (data) => {
  return HTTP_TOKEN.get(
    "integration/external/google/list_campaigns_from_account",
    {
      params: data,
    }
  ).then((result) => {
    return result.data;
  });
};

export const getIntegrationsStatus = () => {
  return HTTP_TOKEN.get("integration/integrations_status").then((result) => {
    return result.data;
  });
};


// login fb and google
export const initFacebookLoginOauth2 = () => {
  return HTTP.get("integration/oauth/facebook-login").then((result) => {
    return result.data;
  });
};

export const initGoogleLoginOauth2 = () => {
  return HTTP.get("integration/oauth/google-login").then((result) => {
    return result.data;
  });
};